import React from 'react'
import { IconTools } from '@tabler/icons-react'

import Button from 'components/ui/button'
import Text from 'components/ui/text'
import { cn } from 'utils/classMerge'
import { translate } from 'utils/translation'

import { useLeadCaptureStore } from '../store/lead-capture-store'

interface DiyPathProps {
  onClick?: () => void | Promise<void>
  className?: string
}

export const DiyPath = ({ onClick, className }: DiyPathProps) => {
  const { isLoading } = useLeadCaptureStore()

  const handleClick = async () => {
    if (onClick) {
      await onClick()
    }
  }

  return (
    <div
      className={cn(
        className,
        `tw-flex tw-flex-col tw-gap-6 tw-rounded-2xl tw-border tw-border-solid tw-border-zinc-200 tw-bg-zinc-50 tw-p-6 tw-text-left md:tw-gap-8 md:tw-p-8 lg:tw-max-w-sm`,
      )}
    >
      <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center">
        <IconTools size={48} stroke={1.5} className="tw-text-orange-500" />
      </div>

      <div className="tw-flex tw-flex-col tw-gap-6 md:tw-gap-8">
        <div className="tw-flex tw-flex-col">
          <Text
            as="h3"
            className="tw-m-0 tw-font-geomanist tw-text-2xl tw-font-bold tw-text-zinc-900"
          >
            onboarding_questionnaire_step7_diy
          </Text>
          <Text className="tw-m-0 tw-text-base tw-font-medium tw-text-zinc-700">
            onboarding_questionnaire_step7_diy_subheading
          </Text>
        </div>

        <Button
          variant="neutral-solid"
          size="lg"
          onClick={handleClick}
          className="tw-w-full"
          isLoading={isLoading}
        >
          {translate('onboarding_questionnaire_step7_diy_button')}
        </Button>

        <Text className="tw-m-0 tw-text-sm tw-text-zinc-500 md:tw-text-base">
          onboarding_questionnaire_step7_diy_brief
        </Text>
      </div>
    </div>
  )
}
